import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, withCtx as _withCtx, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1e90c151"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "market-video" }
const _hoisted_2 = { class: "market-video-content" }
const _hoisted_3 = { class: "market-video-left" }
const _hoisted_4 = { class: "title" }
const _hoisted_5 = { class: "text" }
const _hoisted_6 = { class: "video-btn cursor-pt" }
const _hoisted_7 = { class: "market-video-right" }
const _hoisted_8 = ["src"]
const _hoisted_9 = {
  class: "market-content",
  style: {"background":"#FAFAFA"}
}
const _hoisted_10 = { class: "market-content-item" }
const _hoisted_11 = { class: "market-item-title" }
const _hoisted_12 = { class: "market-item-text" }
const _hoisted_13 = { class: "market-item-part" }
const _hoisted_14 = { class: "part-item wsy" }
const _hoisted_15 = { class: "part-logo" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "https://static-s.theckb.com/BusinessMarket/Client/market/wsy_logo.png",
  alt: ""
}, null, -1))
const _hoisted_17 = { class: "part-content" }
const _hoisted_18 = { class: "part-real" }
const _hoisted_19 = { class: "part-real-item" }
const _hoisted_20 = { class: "part-real-item" }
const _hoisted_21 = { class: "part-real-item" }
const _hoisted_22 = /*#__PURE__*/_createStaticVNode("<div class=\"part-img\" data-v-1e90c151><div class=\"img\" data-v-1e90c151><img src=\"https://static-s.theckb.com/BusinessMarket/Client/market/wsy_1.png\" alt=\"\" data-v-1e90c151></div><div class=\"img\" data-v-1e90c151><img src=\"https://static-s.theckb.com/BusinessMarket/Client/market/wsy_2.png\" alt=\"\" data-v-1e90c151></div><div class=\"img\" data-v-1e90c151><img src=\"https://static-s.theckb.com/BusinessMarket/Client/market/wsy_3.png\" alt=\"\" data-v-1e90c151></div></div>", 1)
const _hoisted_23 = { class: "part-btn" }
const _hoisted_24 = { class: "part-item skw" }
const _hoisted_25 = { class: "part-logo" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "https://static-s.theckb.com/BusinessMarket/Client/market/skw_logo.png",
  alt: ""
}, null, -1))
const _hoisted_27 = { class: "part-content" }
const _hoisted_28 = { class: "part-real" }
const _hoisted_29 = { class: "part-real-item" }
const _hoisted_30 = { class: "part-real-item" }
const _hoisted_31 = { class: "part-real-item" }
const _hoisted_32 = /*#__PURE__*/_createStaticVNode("<div class=\"part-img\" data-v-1e90c151><div class=\"img\" data-v-1e90c151><img src=\"https://static-s.theckb.com/BusinessMarket/Client/market/skw_1.png\" alt=\"\" data-v-1e90c151></div><div class=\"img\" data-v-1e90c151><img src=\"https://static-s.theckb.com/BusinessMarket/Client/market/skw_2.png\" alt=\"\" data-v-1e90c151></div><div class=\"img\" data-v-1e90c151><img src=\"https://static-s.theckb.com/BusinessMarket/Client/market/skw_3.png\" alt=\"\" data-v-1e90c151></div></div>", 1)
const _hoisted_33 = { class: "part-btn" }
const _hoisted_34 = {
  class: "market-content",
  style: {"background":"#fff"}
}
const _hoisted_35 = {
  class: "market-content-item",
  style: {"padding-bottom":"0"}
}
const _hoisted_36 = { class: "market-item-title" }
const _hoisted_37 = { class: "market-item-text" }
const _hoisted_38 = { class: "market-flow" }
const _hoisted_39 = {
  key: 0,
  src: "https://static-s.theckb.com/BusinessMarket/Client/market/follow_2c.png",
  alt: "",
  class: "bg-img"
}
const _hoisted_40 = {
  key: 1,
  src: "https://static-s.theckb.com/BusinessMarket/Client/market/follow_2b.png",
  alt: "",
  class: "bg-img"
}
const _hoisted_41 = { class: "step1" }
const _hoisted_42 = { class: "step2" }
const _hoisted_43 = { class: "step3" }
const _hoisted_44 = {
  class: "market-content",
  style: {"background":"#FAFAFA"}
}
const _hoisted_45 = { class: "market-content-item" }
const _hoisted_46 = { class: "market-item-title" }
const _hoisted_47 = { class: "market-item-text" }
const _hoisted_48 = { class: "market-advantage" }
const _hoisted_49 = { class: "market-advantage-item" }
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "icon-content" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "icon" }, [
    /*#__PURE__*/_createElementVNode("img", {
      src: "https://static-s.theckb.com/BusinessMarket/Client/market/market_Local_icon.svg",
      alt: ""
    })
  ])
], -1))
const _hoisted_51 = { class: "title" }
const _hoisted_52 = { class: "text" }
const _hoisted_53 = { class: "market-advantage-item" }
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "icon-content" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "icon" }, [
    /*#__PURE__*/_createElementVNode("img", { src: "https://static-s.theckb.com/BusinessMarket/Client/market/market_History_icon.svg" })
  ])
], -1))
const _hoisted_55 = { class: "title" }
const _hoisted_56 = { class: "text" }
const _hoisted_57 = { class: "market-advantage-item" }
const _hoisted_58 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "icon-content" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "icon" }, [
    /*#__PURE__*/_createElementVNode("img", {
      src: "https://static-s.theckb.com/BusinessMarket/Client/market/market_Buy_icon.svg",
      alt: ""
    })
  ])
], -1))
const _hoisted_59 = { class: "title" }
const _hoisted_60 = { class: "text" }
const _hoisted_61 = {
  key: 0,
  class: "market-content",
  style: {"background":"#fff"}
}
const _hoisted_62 = { class: "market-content-item" }
const _hoisted_63 = { class: "market-item-title" }
const _hoisted_64 = { class: "market-question" }
const _hoisted_65 = ["onClick"]
const _hoisted_66 = { class: "market-question-textcontent" }
const _hoisted_67 = { class: "title line--only cursor-pt" }
const _hoisted_68 = { class: "text line--2" }
const _hoisted_69 = { class: "btn" }
const _hoisted_70 = ["src"]
const _hoisted_71 = { class: "confirm-content" }
const _hoisted_72 = { class: "confirm-title" }
const _hoisted_73 = { class: "confirm-text" }
const _hoisted_74 = { class: "confirm-btn" }
const _hoisted_75 = { class: "btn-content" }

import { t } from '@/plugins/i18n'
import Category from '@/components/bussiness/Category/Category.vue'
import { ref, onMounted, computed, nextTick } from 'vue'
import { confirmLogin } from '@/util/useConfirm'
import { useStore } from 'vuex'
import { isD2C, isEN, isJA, isKO, useRtfix, useSite, useSite2Station } from '@/store'
import SvgIcon from '@/components/icons/SvgIcon.vue'
import router from '@/router'
import { getArticleListByType } from '@/apis/frog'
import { Site } from '@/common/const'
interface ART_TYPE {
  noLoginRestriction: number;
  noMembershipRestriction?: number;
  frogArticleId?: string
}
interface ARTICLE_TYPE {
  frogArticleId?: string;
  frogArticleSubTitle?: string;
  frogArticleTitle?: string;
  noLoginRestriction: number;
  frogArticleImgUrl?: string
}

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const store = useStore()
const visible = ref(false)
// 插件确认弹窗
const confirmVisible = ref(false)
const user = computed(() => store.getters.user)
const token = store.getters.token
const videoPlay = ref()
// 采购照片区分
const purchaseImg = computed(() => {
  return isD2C() ? [
    'https://static-s.theckb.com/BusinessMarket/Client/market/market_purchase_d2c_1.png',
    'https://static-s.theckb.com/BusinessMarket/Client/market/market_purchase_d2c_2.png',
    'https://static-s.theckb.com/BusinessMarket/Client/market/market_purchase_d2c_3.png'
  ] : [
    'https://static-s.theckb.com/BusinessMarket/Client/market/market_purchase_b2b_1.png',
    'https://static-s.theckb.com/BusinessMarket/Client/market/market_purchase_b2b_2.png',
    'https://static-s.theckb.com/BusinessMarket/Client/market/market_purchase_b2b_3.png'
  ]
})

const stationcode = useSite2Station()
const videoUrl = computed(() => {
  return {
    [Site.JA]: 'https://static-s.theckb.com/BusinessMarket/Client/market/market_video_ja.mp4',
    [Site.EN]: 'https://static-s.theckb.com/BusinessMarket/Client/market/market_video_en.mp4',
    [Site.KO]: 'https://static-s.theckb.com/BusinessMarket/Client/market/market_video_ko.mp4'
  }[stationcode]
})

// 插件是否安装
const isInstall = computed(() => store.getters.isInstall)
// 跳转文章详情
const toArticle = (item: ART_TYPE) => {
  if (!token && item.noLoginRestriction === 3) {
    confirmLogin(async () => { })
    return
  }
  if (item.noMembershipRestriction === 3 && !user?.value?.membership?.templateLevel) {
    store.commit('status/memberDialog', true)
    return
  }
  location.href = process.env.VUE_APP_HELP_URL + useSite() + `/article/${item.frogArticleId}`
}
const channelType = ref()
// 搜款网点击
const skwLearnClick = (type: number) => {
  channelType.value = type
  if (isInstall.value) {
    window.open(type === 1 ? 'https://www.wsy.com/' : 'https://www.vvic.com/')
  } else {
    confirmVisible.value = true
  }
}
// 插件安装
const pluginInstall = () => {
  if (isJA()) {
    window.open('https://chromewebstore.google.com/detail/kaeru%E3%83%84%E3%83%BC%E3%83%ABthe-ckb/cbdgkflbadceflcbbogjkldbnjddnhbl')
  }
  if (isKO()) {
    window.open('https://chromewebstore.google.com/detail/the-ckb-easybuy/pdafojilkicifncfkalgilcpcnejebce')
  }
}
const articleList = ref<ARTICLE_TYPE[]>([])
getArticleListByType({
  pageSize: 10000,
  pageNum: 1,
  showMall: 1
}).then((res) => {
  const { data } = res
  articleList.value = data.records ?? []
})
// 搜款网小技巧链接
const getUrl = () => {
  return process.env.VUE_APP_HELP_URL + useSite() + `/article/${isJA() ? '139' : '140'}`
}

return (_ctx: any,_cache: any) => {
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["market-to-transparent", _unref(useSite)()])
  }, [
    _createVNode(Category),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, _toDisplayString(_unref(t)('这就是市场购！')), 1),
          _createElementVNode("div", _hoisted_5, _toDisplayString(_unref(t)('用户下单即采，采购人员当天直接前往源头采购并检品，最快当天发货，避免国内运输耗时和中间商层层加价，有效控制成本，为客户提供优质货品。')), 1),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", {
              class: "flex-center",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (visible.value = true))
            }, [
              _createElementVNode("span", null, [
                _createTextVNode(_toDisplayString(_unref(t)('视频了解')) + " ", 1),
                _createVNode(SvgIcon, {
                  name: "Play (播放)",
                  class: "svg-icon"
                })
              ])
            ])
          ]),
          ((!_unref(isInstall).value) && !_unref(isEN)())
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "pluginInstall",
                onClick: pluginInstall
              }, _toDisplayString(_unref(t)('插件下载')), 1))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("video", {
            src: _unref(videoUrl),
            ref: (_value, _refs) => {
              _refs['videoPlay'] = _value
              videoPlay.value = _value
            },
            controls: "",
            autoplay: "",
            muted: ""
          }, null, 8, _hoisted_8)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_9, [
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("div", _hoisted_11, _toDisplayString(_unref(t)('代采平台')), 1),
        _createElementVNode("div", _hoisted_12, _toDisplayString(_unref(t)('以下平台支持直接采购，快挑选您心仪的商品吧！')), 1),
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("div", _hoisted_15, [
              _hoisted_16,
              _createElementVNode("div", _hoisted_17, _toDisplayString(_unref(t)('中国杭州第一家获淘宝官方正式授权的批发平台')), 1)
            ]),
            _createElementVNode("div", _hoisted_18, [
              _createElementVNode("div", _hoisted_19, [
                _createVNode(SvgIcon, {
                  name: "勾",
                  class: "svg-icon"
                }),
                _createElementVNode("span", null, _toDisplayString(_unref(t)('精品男装')), 1)
              ]),
              _createElementVNode("div", _hoisted_20, [
                _createVNode(SvgIcon, {
                  name: "勾",
                  class: "svg-icon"
                }),
                _createElementVNode("span", null, _toDisplayString(_unref(t)('源头直采')), 1)
              ]),
              _createElementVNode("div", _hoisted_21, [
                _createVNode(SvgIcon, {
                  name: "勾",
                  class: "svg-icon"
                }),
                _createElementVNode("span", null, _toDisplayString(_unref(t)('快速发货')), 1)
              ])
            ]),
            _hoisted_22,
            _createElementVNode("div", _hoisted_23, [
              _createElementVNode("div", {
                onClick: _cache[1] || (_cache[1] = () => {
                _unref(router).push(_unref(useRtfix)('market_wsy'))
              }),
                class: "btn"
              }, _toDisplayString(_unref(t)('采购商品2')), 1),
              (!_unref(isEN)())
                ? (_openBlock(), _createElementBlock("a", {
                    key: 0,
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (skwLearnClick(1)))
                  }, _toDisplayString(_unref(t)('去原网站选品')), 1))
                : _createCommentVNode("", true)
            ])
          ]),
          _createElementVNode("div", _hoisted_24, [
            _createElementVNode("div", _hoisted_25, [
              _hoisted_26,
              _createElementVNode("div", _hoisted_27, _toDisplayString(_unref(t)('中国广州市最大的服装批发平台。')), 1)
            ]),
            _createElementVNode("div", _hoisted_28, [
              _createElementVNode("div", _hoisted_29, [
                _createVNode(SvgIcon, {
                  name: "勾",
                  class: "svg-icon"
                }),
                _createElementVNode("span", null, _toDisplayString(_unref(t)('精品女装')), 1)
              ]),
              _createElementVNode("div", _hoisted_30, [
                _createVNode(SvgIcon, {
                  name: "勾",
                  class: "svg-icon"
                }),
                _createElementVNode("span", null, _toDisplayString(_unref(t)('一手货源')), 1)
              ]),
              _createElementVNode("div", _hoisted_31, [
                _createVNode(SvgIcon, {
                  name: "勾",
                  class: "svg-icon"
                }),
                _createElementVNode("span", null, _toDisplayString(_unref(t)('真实档口')), 1)
              ])
            ]),
            _hoisted_32,
            _createElementVNode("div", _hoisted_33, [
              _createElementVNode("div", {
                onClick: _cache[3] || (_cache[3] = () => {
                _unref(router).push(_unref(useRtfix)('market_vvic'))
              }),
                class: "btn"
              }, _toDisplayString(_unref(t)('采购商品2')), 1),
              (!_unref(isEN)())
                ? (_openBlock(), _createElementBlock("a", {
                    key: 0,
                    href: "javascript:;",
                    onClick: _cache[4] || (_cache[4] = ($event: any) => (skwLearnClick(2)))
                  }, _toDisplayString(_unref(t)('去原网站选品2')), 1))
                : _createCommentVNode("", true)
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_34, [
      _createElementVNode("div", _hoisted_35, [
        _createElementVNode("div", _hoisted_36, _toDisplayString(_unref(t)('采购流程')), 1),
        _createElementVNode("div", _hoisted_37, _toDisplayString(_unref(t)('平台采购将通过以下流程高效且便捷地完成')), 1),
        _createElementVNode("div", _hoisted_38, [
          (_unref(isD2C)())
            ? (_openBlock(), _createElementBlock("img", _hoisted_39))
            : (_openBlock(), _createElementBlock("img", _hoisted_40)),
          _createElementVNode("div", _hoisted_41, _toDisplayString(_unref(t)('用户当天下午2点前下单')), 1),
          _createElementVNode("div", _hoisted_42, _toDisplayString(_unref(t)('当天线下采购并检品出库')), 1),
          _createElementVNode("div", _hoisted_43, _toDisplayString(_unref(t)('商品送达')), 1)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_44, [
      _createElementVNode("div", _hoisted_45, [
        _createElementVNode("div", _hoisted_46, _toDisplayString(_unref(t)('代采优势')), 1),
        _createElementVNode("div", _hoisted_47, _toDisplayString(_unref(t)('直行便提供信息透明、交易高效、服务完善的采购环境，买家可以更方便、快捷地完成采购')), 1),
        _createElementVNode("div", _hoisted_48, [
          _createElementVNode("div", _hoisted_49, [
            _hoisted_50,
            _createElementVNode("div", _hoisted_51, _toDisplayString(_unref(t)('丰富的款式')), 1),
            _createElementVNode("div", _hoisted_52, _toDisplayString(_unref(t)('直接从中国各地主要批发市场采购，实时更新商品，紧跟最新潮流趋势。')), 1)
          ]),
          _createElementVNode("div", _hoisted_53, [
            _hoisted_54,
            _createElementVNode("div", _hoisted_55, _toDisplayString(_unref(t)('极高的性价比')), 1),
            _createElementVNode("div", _hoisted_56, _toDisplayString(_unref(t)('提供比阿里巴巴价格低一半以下的商品。通过直接采购，大幅降低中间成本。')), 1)
          ]),
          _createElementVNode("div", _hoisted_57, [
            _hoisted_58,
            _createElementVNode("div", _hoisted_59, _toDisplayString(_unref(t)('独特的商品')), 1),
            _createElementVNode("div", _hoisted_60, _toDisplayString(_unref(t)('大量未在网上销售的独家商品，提供与众不同的独特商品选择。')), 1)
          ])
        ])
      ])
    ]),
    (articleList.value.length > 2)
      ? (_openBlock(), _createElementBlock("div", _hoisted_61, [
          _createElementVNode("div", _hoisted_62, [
            _createElementVNode("div", _hoisted_63, _toDisplayString(_unref(t)('常见问题')), 1),
            _createElementVNode("div", _hoisted_64, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(articleList.value, (item) => {
                return (_openBlock(), _createElementBlock("div", {
                  onClick: ($event: any) => (toArticle(item)),
                  class: "market-question-item",
                  key: item.frogArticleId
                }, [
                  _createElementVNode("div", {
                    class: "market-question-img cursor-pt",
                    style: _normalizeStyle(`background-image: url('${item.frogArticleImgUrl}')`)
                  }, null, 4),
                  _createElementVNode("div", _hoisted_66, [
                    _createElementVNode("div", _hoisted_67, _toDisplayString(item.frogArticleTitle), 1),
                    _createElementVNode("div", _hoisted_68, _toDisplayString(item.frogArticleSubTitle), 1),
                    _createElementVNode("div", _hoisted_69, [
                      _createElementVNode("a", null, _toDisplayString(_unref(t)('了解详情')), 1)
                    ])
                  ])
                ], 8, _hoisted_65))
              }), 128))
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_el_dialog, {
      modelValue: visible.value,
      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((visible).value = $event)),
      width: "1200px",
      "destroy-on-close": "",
      "custom-class": "market-transparent-dialog",
      onClose: _cache[6] || (_cache[6] = ($event: any) => (visible.value = false))
    }, {
      default: _withCtx(() => [
        _createElementVNode("video", {
          src: _unref(videoUrl),
          style: {"width":"1200px"},
          controls: "",
          autoplay: ""
        }, null, 8, _hoisted_70)
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      modelValue: confirmVisible.value,
      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((confirmVisible).value = $event)),
      "custom-class": "market-transparent-confirm-dialog",
      onClose: _cache[10] || (_cache[10] = ($event: any) => (confirmVisible.value = false)),
      "show-close": false
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_71, [
          _createElementVNode("div", _hoisted_72, _toDisplayString(_unref(t)('提示')), 1),
          _createElementVNode("span", {
            class: "iconfont icon-guanbi2",
            onClick: _cache[7] || (_cache[7] = ($event: any) => (confirmVisible.value = false))
          }),
          _createElementVNode("div", _hoisted_73, _toDisplayString(_unref(t)('您的浏览器未安装商品导入插件，安装插件后，您才可以把找到的商品一键导入到CKB。')), 1),
          _createElementVNode("div", _hoisted_74, [
            _createElementVNode("div", _hoisted_75, [
              _createVNode(_component_el_button, {
                class: "btn",
                onClick: _cache[8] || (_cache[8] = ($event: any) => (confirmVisible.value = false))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)('暂不安装')), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_button, {
                type: "primary",
                class: "btn",
                onClick: pluginInstall
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)('立即安装')), 1)
                ]),
                _: 1
              })
            ])
          ])
        ])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 2))
}
}

})